import React, { useContext } from "react";
import PropTypes from "prop-types";
import { NavLink, Outlet } from "react-router-dom";
import AppContext from "../../../AppContext";
import Breadcrumb from "../../Breadcrumb";
import { langComponent } from "../../../constants";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
const prefix = "faqs-support-layout";
const Layout = ({ tabs, title }) => {
  const navigate = useNavigate();
  const { getLang, faqs } = useContext(AppContext);
  const Translation = getLang(langComponent.support);
  const getTopicRender = (icon, topic, to) => {
    return (
      <div
        className={`${prefix}-topics-item`}
        onClick={() => navigate(`${to}`)}
      >
        <div className={`${prefix}-topics-item__icon`}>
          <img src={icon}></img>
        </div>
        <div className={`${prefix}-topics-item__name`}>
          {Translation(topic)}
        </div>
      </div>
    );
  };
  return (
    <div className={prefix}>
      <Breadcrumb
        config={[
          {
            path: "/support",
            breadcrumb: "Support",
            props: { pathname: `/support/faqs` },
          },
          {
            path: "/support/join",
            breadcrumb: `${_.upperFirst(title)}`,
            props: { noLink: true },
          },
          {
            path: "/support",
            breadcrumb: `${title}`,
            props: { pathname: `/support/${title}` },
          },
        ]}
      />
      <h1 className={`${prefix}__header`}>{Translation(`${title}`)}</h1>
      <div className={`${prefix}-topics`}>
        {tabs.map((t, i) => {
          return getTopicRender(t.icon, t.title, t.path);
        })}
      </div>
    </div>
  );
};

Layout.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.array,
};

Layout.defaultProps = {
  title: "",
  tabs: [],
};

export default Layout;
